import PropTypes from 'prop-types';

export default PropTypes.shape({
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  name: PropTypes.string.isRequired,
  imageUrl: PropTypes.string,
});



// WEBPACK FOOTER //
// ./src/types/ProductCategoryType.js